export const CookieConsentCategory = {
  NECESSARY: 'necessary',
  AD: 'ad',
  ANALYTICS: 'analytics',
  FUNCTIONALITY: 'functionality',
  PERSONALIZATION: 'personalization',
};
